import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { setDialog } from "../../store/slices/global";
import { QueryMeta } from "../../types/react-query";
import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { organizationDomainKey } from "../queryKeys";

const getShopDomain = async () => {
  const resp = await api.get<string>("/v2/shops/domain");
  return resp.data;
};

export const useGetShopDomain = () => {
  const org = useGetOrg();
  const dispatch = useDispatch();
  return useQuery<string, Error>({
    queryKey: organizationDomainKey.one(org.data.org.id),
    queryFn: async () => getShopDomain(),
    meta: {
      onSuccess: (data: string | undefined) => {
        if (!data) {
          dispatch(setDialog({ dialog: "setDomain", open: true }));
        }
      },
    } as QueryMeta,
  });
};
